/* eslint-disable jsx-quotes */
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CredentialsHelper from '../../../../utils/credentials-helper';
import routes from '../../../../utils/routes';
import { fetchAdminData, updateCourse } from './admin-pages.actions';
import InternalPageTypes from '../../internal-page-types';
import Courses from '../../../courses/courses';
import Classes from '../../../classes/classes';
import TCCs from '../../../tccs/tccs';
import OnlineTests from '../../../online-tests/online-tests';
import AddQuestion from '../../../add-question/add-question';
import ManageQuestion from '../../../manage-question/manage-question';
import AddTemplateTest from '../../../add-template-test/add-template-test';
import ManageTemplateTest from '../../../manage-template-test/manage-template-test';
import DuplicateTemplateTest from '../../../duplicate-template-test/duplicate-template-test';
import DuplicateQuestion from '../../../duplicate-question/duplicate-question';
import Users from '../../../users/users';
import Global from '../../../global/global';
import Admins from '../../../admins/admins';
import Trainers from '../../../trainers/trainers';
import Wrapper from '../pages-wrapper';
import Section from '../../../section/section';
import './admin-pages.css';
import {
    fetchClass,
    fetchCourse,
    updateClass,
} from '../../../section/section.actions';
import { saveChanges } from '../../../app/app.actions';

class AdminPages extends React.Component {
    componentDidMount() {
        if (CredentialsHelper.isLoggedIn) {
            this.props.fetchAdminData();
        }
    }

    render() {
        if (!CredentialsHelper.isLoggedIn) {
            return <Redirect to={routes.LOGIN} />;
        }
        return (
            <div className="admin-wrapper">
                <Switch>
                    <Route exact path={routes.COURSES} component={Courses} />
                    <Route exact path={routes.CLASSES} component={Classes} />
                    <Route exact path={routes.TCCS} component={TCCs} />
                    <Route
                        exact
                        path={routes.QUESTIONS_DATABASE}
                        component={OnlineTests}
                    />
                    <Route
                        exact
                        path={routes.TEMPLATE_TESTS}
                        component={OnlineTests}
                    />
                    <Route
                        exact
                        path={routes.PERFORMED_TESTS}
                        component={OnlineTests}
                    />
                    <Route
                        exact
                        path={routes.ADD_QUESTION}
                        component={AddQuestion}
                    />
                    <Route
                        exact
                        path={routes.MANAGE_QUESTION}
                        component={ManageQuestion}
                    />
                    <Route
                        exact
                        path={routes.DUPLICATE_QUESTION}
                        component={DuplicateQuestion}
                    />
                    <Route
                        exact
                        path={routes.ADD_TEMPLATE_TEST}
                        component={AddTemplateTest}
                    />
                    <Route
                        exact
                        path={routes.MANAGE_TEMPLATE_TEST}
                        component={ManageTemplateTest}
                    />
                    <Route
                        exact
                        path={routes.DUPLICATE_TEMPLATE_TEST}
                        component={DuplicateTemplateTest}
                    />
                    <Route exact path={routes.USERS} component={Users} />
                    <Route exact path={routes.GLOBAL} component={Global} />
                    <Route exact path={routes.ADMINS} component={Admins} />
                    <Route exact path={routes.TRAINERS} component={Trainers} />
                    <Route
                        path={routes.COURSE_RESOURCES(':id')}
                        component={SectionWithCourses}
                    />
                    <Route
                        path={routes.CLASS_RESOURCES(':id')}
                        component={SectionWithClasses}
                    />
                    <Redirect to={routes.ROOT} />
                </Switch>
            </div>
        );
    }
}

export default connect(null, dispatch =>
    bindActionCreators({ fetchAdminData }, dispatch),
)(AdminPages);

class WrappedSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = { scrollTop: false };
        this.scrollListen = this.scrollListen.bind(this);
    }

    scrollListen() {
        let scroll = window.scrollY;
        if (scroll > 100) {
            this.setState({ scrollTop: true });
        } else {
            this.setState({ scrollTop: false });
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.scrollListen);
        const { idProp, match } = this.props;
        if (idProp === 'classId') {
            this.props.fetchClass(match.params.id);
        } else if (idProp === 'courseId') {
            this.props.fetchCourse(match.params.id);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollListen);
    }

    render() {
        const { pageType } = this.props;
        return (
            <Wrapper
                pageType={pageType}
                scroll={this.state.scrollTop}
                {...this.props}
            >
                <Section pageType={pageType} {...this.props} />
            </Wrapper>
        );
    }
}

const SectionWithCourses = connect(
    ({ courses }) => ({
        classes: courses.data,
        idProp: 'courseId',
        links: [{ title: 'Cursos', url: routes.COURSES }],
        pageType: InternalPageTypes.COURSE_RESOURCE,
    }),
    dispatch =>
        bindActionCreators(
            { updateNestedItem: updateCourse, saveChanges, fetchCourse },
            dispatch,
        ),
)(WrappedSection);

const SectionWithClasses = connect(
    ({ classes }) => ({
        classes: classes.data,
        idProp: 'classId',
        links: [{ title: 'Turmas', url: routes.CLASSES }],
        pageType: InternalPageTypes.CLASS_RESOURCE,
    }),
    dispatch =>
        bindActionCreators(
            { updateNestedItem: updateClass, saveChanges, fetchClass },
            dispatch,
        ),
)(WrappedSection);



// WEBPACK FOOTER //
// ./src/components/internal-pages/components/admin-pages/admin-pages.js